export * from './dlg-confirm.component';
